import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { ChipIconComponent } from './chip-icon.component';
import { MaterialMdcModule } from '../../material-mdc.module';
import { SharedModule } from '../../shared.module';

@NgModule({
  declarations: [
    ChipIconComponent
  ],
  imports: [
    CommonModule,
    MaterialMdcModule,
    SharedModule
  ],
  exports: [
    ChipIconComponent
  ]
})
export class ChipIconModule { }
